import Vue from 'vue';
import Router from 'vue-router';
// import axios from 'axios';
import VueAxios from 'vue-axios';
import axios from './backend/vue-axios';
import MapView from './views/MapView.vue';
import Report from './views/Report.vue';
import ReportDetail from './views/ReportDetail.vue';
import AddInfoTrain from './views/AddInfoTrain.vue';
import AddInfoBus from './views/AddInfoBus.vue';
import DashboardRoad from './views/DashboardRoad.vue';
import DashboardRail from './views/DashboardRail.vue';
import DashboardWater from './views/DashboardWater.vue';
import DashboardAir from './views/DashboardAir.vue';
import AddInfo from './views/AddInfo.vue';
import Duplicate from './views/Duplicate.vue';
import EditDuplicate from './views/EditDuplicate.vue';
import Setting from './views/Setting.vue';
import DashboardReport from './views/DashboardReport.vue';
import MainDashboard from './views/MainDashboard.vue';
import ReportExecutive from './views/Reportexecutive.vue';
import RoadExecutive from './views/RoadExecutive.vue';
import RailExecutive from './views/RailExecutive.vue';
import WaterExecutive from './views/WaterExecutive.vue';
import AirExecutive from './views/AirExecutive.vue';
import UnauthorizedDialog from './views/UnauthorizedDialog.vue';

Vue.use(Router);
Vue.use(VueAxios, axios);

function initHomePath(to, from, next) {
  // if login go to map
  // else go to dasdboard
  next({
    path: '/main-dashboard'
    // params: {
    //   aa: 'aa' // send param
    // },
    // query: {
    //   aa: 'aa' // add query
    // }
  });
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: MainDashboard,
      beforeEnter: initHomePath
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   beforeEnter: requiredLogin,
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      path: '/map',
      name: 'map',
      component: MapView
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/report_detail',
      name: 'report_detail',
      component: ReportDetail,
      props: true
    },
    {
      path: '/addinfo-train',
      name: 'addinfo_train',
      component: AddInfoTrain
    },
    {
      path: '/addinfo-bus',
      name: 'addinfo_bus',
      component: AddInfoBus
    },
    {
      path: '/dashboard-road',
      name: 'dashboard-road',
      component: DashboardRoad
    },
    {
      path: '/dashboard-rail',
      name: 'dashboard-rail',
      component: DashboardRail
    },
    {
      path: '/dashboard-water',
      name: 'dashboard-water',
      component: DashboardWater
    },
    {
      path: '/dashboard-air',
      name: 'dashboard-air',
      component: DashboardAir
    },
    {
      path: '/report-executive',
      name: 'report-executive',
      component: ReportExecutive
    },
    {
      path: '/report-executive/road',
      name: 'road-executive',
      component: RoadExecutive
    },
    {
      path: '/report-executive/rail',
      name: 'rail-executive',
      component: RailExecutive
    },
    {
      path: '/report-executive/water',
      name: 'water-executive',
      component: WaterExecutive
    },
    {
      path: '/report-executive/air',
      name: 'air-executive',
      component: AirExecutive
    },
    {
      path: '/addinfo',
      name: 'addinfo',
      component: AddInfo
    },
    {
      path: '/duplicate',
      name: 'duplicate',
      component: Duplicate
    },
    {
      path: '/duplicate_detail',
      name: 'duplicate_detail',
      component: EditDuplicate
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting
    },
    {
      path: '/dashboard_report',
      name: 'dashboard_report',
      component: DashboardReport
    },
    {
      path: '/main-dashboard',
      name: 'main_dashboard',
      component: MainDashboard
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: UnauthorizedDialog
    }
  ],
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL
});

export default router;
